import type { KhutbahLine } from '@noorview/core';
import { backend } from './store';

/**
 * One live feed per khutbah for the whole dashboard, however many previews show it (each screen's thumbnail, the
 * live preview, the Live Khutbah sheet): they all get every line so far, then each new or updated line.
 */
const hubs = new Map<string, { lines: Map<number, KhutbahLine>; subs: Set<(lines: KhutbahLine[]) => void>; stop: () => void }>();

export function subscribeKhutbah(broadcastId: string, cb: (lines: KhutbahLine[]) => void): () => void {
  let hub = hubs.get(broadcastId);
  if (!hub) {
    const h = { lines: new Map<number, KhutbahLine>(), subs: new Set<(lines: KhutbahLine[]) => void>(), stop: () => {} };
    h.stop = backend.watchKhutbah(broadcastId, (fresh) => {
      for (const l of fresh) h.lines.set(l.seq, l);
      h.subs.forEach((s) => s(fresh));
    });
    hubs.set(broadcastId, h);
    hub = h;
  }
  hub.subs.add(cb);
  if (hub.lines.size) cb([...hub.lines.values()]);
  return () => {
    const h = hubs.get(broadcastId);
    if (!h) return;
    h.subs.delete(cb);
    if (!h.subs.size) { h.stop(); hubs.delete(broadcastId); }
  };
}

/** Everything said so far in a khutbah (for the transcript). */
export const khutbahSoFar = (broadcastId: string) => [...(hubs.get(broadcastId)?.lines.values() ?? [])].sort((a, b) => a.seq - b.seq);
